import { FC, ReactNode } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";

interface SegmentPageLayoutProps {
  title: string;
  children: ReactNode;
  toolbar?: ReactNode;
  action?: ReactNode;
}

export const SegmentPageLayout: FC<SegmentPageLayoutProps> = ({
  title,
  children,
  toolbar,
  action,
}) => {
  return (
    <Stack direction="column" padding={3} height="100%" overflow="hidden">
      <Box
        mb={3}
        pl={1}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        gap={2}
      >
        <Typography
          fontSize={{ xs: "24px", sm: "32px" }}
          fontWeight={300}
          sx={{ minWidth: 0 }}
        >
          {title}
        </Typography>
        {action}
      </Box>

      {toolbar && <Box mb={2}>{toolbar}</Box>}

      <Box display="flex" flexDirection="column" flex={1} overflow="hidden">
        {children}
      </Box>
    </Stack>
  );
};
